<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="credit-card"
    title="Пополнение баланса"
    (close)="senderService.isOpenedAddBalance = true"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div class="text-muted px-5 pb-5 mt-5">Введите сумму для пополения</div>
      <!--<nz-input-number-group *nzSpaceItem [nzAddOnAfter]="addOnAfterTemplate">-->
      <nz-input-group [nzSize]="'large'" class="px-5 pb-5">
        <nz-input-number class="mr-3" (ngModelChange)="generatePayUrl()" [(ngModel)]="amount" [nzMin]="1" [nzMax]="75000"
                         [nzStep]="100"></nz-input-number>
        <nz-select [style.width.px]="90" (ngModelChange)="generatePayUrl()" [(ngModel)]="currency" style="width: 60px">
          <nz-option *ngFor="let item of arCurrency" [nzLabel]="item" [nzValue]="item"></nz-option>

        </nz-select>
        <ng-template #addOnAfterTemplate>

        </ng-template>
      </nz-input-group>
      <div class="text-muted px-5 pb-5">Для оплаты перейдите по
        <a [href]="payUrl" target="_blank">ссылке</a>
      </div>

      <!--</nz-input-number-group>-->
      <!--<iframe *ngIf="payUrl !== 'about:blank'; else load" height="480" (load)="resizeIframe($event)" class="w-100" [src]="payUrl" frameborder="0"></iframe>-->
      <ng-template #load>
        <div [style.height.px]="400" class="w-100"></div>
      </ng-template>
    </div>
  </div>
</div>
